export default __webpack_public_path__ + "static/media/1.136fefd6.png";